import { RegistrationManager } from "../RegistrationManager";
import { ApiClientFactory } from "./clients";

export class RegistrationManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/registration`
    );
  }

  createRegistrationManager(): RegistrationManager {
    return new RegistrationManager(this.apiClientFactory.createApiClient());
  }
}
